import React from 'react'

import {
    MasonaryGrid,
    Image,
    TickIcon,
    TickIconInactive,
    TickIconImage,
} from './styles'

const FeedbackGif = props => {
    const isGifClicked = () => {
        const gifIndex = props.selectedGifs.findIndex(
            item => item.id === props.gif.id
        )
        return gifIndex > -1
    }

    return (
        <MasonaryGrid
            onClick={() => props.addGif()}
            isGifClicked={isGifClicked()}
        >
            {isGifClicked() ? (
                <TickIcon>
                    <TickIconImage src={'/img/feedback/tickMark.svg'} />
                </TickIcon>
            ) : (
                <TickIconInactive>
                    <TickIconImage src={'/img/feedback/tickMarkInactive.svg'} />
                </TickIconInactive>
            )}
            <Image src={props.gif.gif} />
        </MasonaryGrid>
    )
}

export default FeedbackGif
